import { render, staticRenderFns } from "./CreditsCreate.vue?vue&type=template&id=1bc0664c"
import script from "./CreditsCreate.vue?vue&type=script&lang=js"
export * from "./CreditsCreate.vue?vue&type=script&lang=js"
import style0 from "./CreditsCreate.vue?vue&type=style&index=0&id=1bc0664c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports